export default function GenerationDrawer({
  isOpen,
  title,
  instructions,
  onInstructionsChange,
  onClose,
  onConfirm,
  isGenerating,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="drawer-shell">
      <button type="button" className="drawer-backdrop" onClick={onClose} aria-label="Close generation drawer" />
      <aside className="finding-drawer">
        <div className="panel-header">
          <div>
            <p className="eyebrow">Generate</p>
            <h2>{title}</h2>
          </div>
          <button type="button" className="ghost-button" onClick={onClose}>
            Cancel
          </button>
        </div>

        <label className="field">
          <span>Additional Information</span>
          <textarea
            rows={10}
            value={instructions}
            onChange={(event) => onInstructionsChange(event.target.value)}
            placeholder="Optional: ask for a rephrase, add impact context, remove a claim, shorten a paragraph, or emphasize a particular angle."
          />
        </label>

        <div className="drawer-actions">
          <button type="button" className="secondary-button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="primary-button" onClick={onConfirm} disabled={isGenerating}>
            {isGenerating ? "Generating..." : "Generate"}
          </button>
        </div>
      </aside>
    </div>
  );
}
